import {TrDialog} from "../../Models/tr-dialog";
import {SaveDialog} from "../../Models/save-dialog";
import {IPromise} from "angular";
import {DataResponse} from "../../../Cirrus/tlDataServices/DataResponse";

const SaveDialogView = require('./save-dialog.html');

interface IScope extends ng.IScope {
  dialog: TrDialog;
  failed: boolean;
  errorMessage: string;
  details: string;
  factory: () => IPromise<any>;
  resolve: () => void;
  reject: () => void;
  retry: () => void;
  cancel: () => void;
}

export const SaveDialogDirective = [
  () => {
    return {
      restrict: 'E',
      scope: {instance: '='},
      templateUrl: SaveDialogView,
      link: (scope: IScope) => {
        scope.dialog = new TrDialog();

        scope.retry = () => {
          run();
        };

        scope.cancel = () => {
          scope.dialog.close();
          scope.reject();
        };

        scope.$watch('instance', (value: SaveDialog) => {
          value.open = (factory: () => IPromise<any>) => {
            return new Promise<void>((resolve, reject) => {
              scope.resolve = resolve;
              scope.reject = reject;
              scope.factory = factory;
              scope.dialog.open();

              run();
            });
          };
        });

        function run() {
          scope.failed = false;
          scope.factory()
            .then(res => {
              scope.resolve();
            })
            .catch((err: DataResponse<any>) => {
              scope.failed = true;
              scope.errorMessage = 'Fehler beim Speichern';
              scope.details = err.data;
            });
        }
      },
    }
  }
];